
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1isd1_1o1wi_145",
  "marker--line": "awsui_marker--line_1isd1_1o1wi_185",
  "marker--rectangle": "awsui_marker--rectangle_1isd1_1o1wi_189",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_1isd1_1o1wi_196",
  "marker--dashed": "awsui_marker--dashed_1isd1_1o1wi_212"
};
  